"use client";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { paymentMethods } from "~/constants/paymentMethods";
import * as colors from "~/theme/colors";

import { PAYMENT_METHOD_CLASSES } from "./constants";

interface StylesProps {
  type?: string;
}

export const PaymentMethodContainer = styled(Box)<StylesProps>(({ type }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
  border: `1px solid ${colors.COLOR_GREYSCALE_NTA_BLACK_15}`,
  borderRadius: 6,
  height: 48,
  width: 70,
  backgroundColor:
    type === paymentMethods.AMERICANEXPRESS || type === paymentMethods.AMEX
      ? "#1F72CD"
      : undefined,
  padding: type === paymentMethods.ME2YOU_VOUCHER ? "8px 5px" : undefined,
  [`& .${PAYMENT_METHOD_CLASSES.image}`]: {
    width: "100%",
  },
}));
